export enum ShipmentFilterName {
  References = 'references',
  ActualDepartureTimeLoad = 'actualDepartureTimeLoad',
  ActualDepartureTimeTOAndWaybill = 'actualDepartureTimeTOAndWaybill',
  ArrivalTime = 'arrivalTime',
  CarrierTOs = 'carrierTOs',
  Carriers = 'carriers',
  CommercialInvoiceNumbers = 'commercialInvoiceNumbers',
  Consignees = 'consignees',
  ConsigneePlants = 'consigneePlants',
  ContractIdentifiers = 'contractIdentifiers',
  DeliveryNoteNumbers = 'deliveryNoteNumbers',
  DeliveryServices = 'deliveryServices',
  DepartureTime = 'departureTime',
  DeviationTypes = 'deviationTypes',
  DeviationHours = 'deviationHours',
  EquipmentIds = 'equipmentIds',
  EstimatedDepartureTimeLoad = 'estimatedDepartureTimeLoad',
  EstimatedDepartureTimeTOAndWaybill = 'estimatedDepartureTimeTOAndWaybill',
  FlightNumbers = 'flightNumbers',
  BusinessUnits = 'businessUnits',
  InboundPlants = 'inboundPlants',
  InboundRegions = 'inboundRegions',
  IStarNumbers = 'iStarNumbers',
  LoadNumbers = 'loadNumbers',
  MaterialNumbers = 'materialNumbers',
  MRPControllers = 'mrpControllers',
  Origins = 'origins',
  OutboundRegions = 'outboundRegions',
  Pickups = 'pickups',
  PlannedDepartureTimeLoad = 'plannedDepartureTimeLoad',
  PlannedDepartureTimeTOAndWaybill = 'plannedDepartureTimeTOAndWaybill',
  PurchaseOrderNumbers = 'purchaseOrderNumbers',
  ReasonCodes = 'reasonCodes',
  ShipToPlants = 'shipToPlants',
  ShipTos = 'shipTos',
  StatusCodes = 'statusCodes',
  Statuses = 'statuses',
  TrailerPlates = 'trailerPlates',
  TransportModes = 'transportModes',
  TransportOrderNumbers = 'transportOrderNumbers',
  TruckPlates = 'truckPlates',
  VesselNames = 'vesselNames',
  Waybills = 'waybills',
  NetworkParts = 'networkParts',
  ConsignorAddresses = 'consignorAddresses',
  FreightPayers = 'freightPayers',
  RbPoNumbers = 'rbPoNumbers',
  UnNumbers = 'unNumbers',
  RouteIds = 'routeIds',
  BarcodeIds = 'barcodeIds',
  BoschOrderNumbers = 'boschOrderNumbers',
  CustomerOrderNumbers = 'customerOrderNumbers',
  BoschMaterialNumbers = 'boschMaterialNumbers',
  CustomerMaterialNumbers = 'customerMaterialNumbers',
  SapIds = 'sapIds',
  HUIds = 'huIds',
  ServiceTypes = 'serviceTypes',
  SecondaryEtaSources = 'secondaryEtaSources',
  SourceCountries = 'sourceCountries',
  DestinationCountries = 'destinationCountries',
  SourceLocations = 'sourceLocations',
  DestinationLocations = 'destinationLocations',
  PortsOfLoading = 'portsOfLoading',
  PortsOfDischarge = 'portsOfDischarge',
  PortsOfLoadingCountries = 'portsOfLoadingCountries',
  PortsOfDischargeCountries = 'portsOfDischargeCountries',
  PortsOfLoadingRegions = 'portsOfLoadingRegions',
  PortsOfDischargeRegions = 'portsOfDischargeRegions',
  EtaTransferInSap = 'etaTransferInSap',
  EtaUpdateInSap = 'etaUpdateInSap',
}
